import { Game } from './game/Game';

// Wait for DOM to load
document.addEventListener('DOMContentLoaded', () => {
  const game = new Game();
  
  const startButton = document.getElementById('start-button');
  const titleScreen = document.getElementById('title-screen');
  
  startButton?.addEventListener('click', () => {
    titleScreen!.style.display = 'none';
    game.start();
  });
});
